import {
  PRIVACY_TERMS,
  SERVICE_TERMS,
} from "../../../lib/constants/terms.constants";
import { useModalStore } from "../../../lib/store/useModalStore";
import { cn } from "../../../lib/utils/cn";
import { vw } from "../../../lib/utils/responsiveUtils";

interface FooterProps {
  className?: string;
}

export default function Footer({ className }: FooterProps) {
  const { openModal } = useModalStore();

  return (
    <footer
      className={cn(
        "bg-[#f4f4f4] text-[#888] font-[500] px-4 py-5 space-y-[14px]",
        className,
      )}
    >
      <p className="text-[#222] font-bold">(주)픽셀소프트웨어</p>
      <div className="mx-auto space-y-[1.5px] text-left text-sm">
        <p>대표이사 : 강성무</p>
        <p>
          사업장소재지 : 서울특별시 강남구 테헤란로 108길 23, 브이씨 빌딩 2층
        </p>
        <p>대표전화 : 02-523-5175 / 02-523-5176</p>
        <p>전자우편 : fixel@fixelsoft.com</p>
        <p className="mt-[1.5px]">사업자등록번호: 888-87-00380</p>
        {/* <div className="space-x-[15px]">
            <span>통신판매업 신고번호: 제2023-서울강남-1234호</span>
            <span className="text-[#222] font-bold underline cursor-pointer" onClick={() => window.open('https://bizno.net/article/8888700380', 'newWindow')}>사업자정보확인</span>
        </div> */}
      </div>
      {/* <img
        style={{ width: vw(50), height: vw(50) }} 
        src="/images/escrow.png"
        onClick={() => {
          window.location.href =
            "https://pg.nicepay.co.kr/issue/IssueEscrow.jsp?Mid=fixel0001m&CoNo=8888700380";
        }}
      /> */}
      <img
        src="https://asset.vcparkgolf.com/escrow/escrow.png"
        style={{ width: vw(50), height: vw(50) }}
        onClick={() => {
          window.open(
            "https://pg.nicepay.co.kr/issue/IssueEscrow.jsp?Mid=fixel0001m&CoNo=8888700380",
            "escrowHelp",
            "width=600,height=500,scrollbars=yes,resizable=yes",
          );
        }}
      />
      <div className="h-[1px] w-full bg-[#e6e6e6]" />
      <div className="flex-row gap-[15px]">
        {/* <span>이용 약관</span> */}
        <span
          className="text-sm font-bold"
          onClick={() =>
            openModal("TERMS_MODAL", {
              title: "약관",
              html: PRIVACY_TERMS,
              type: "privacy",
            })
          }
        >
          개인정보 처리방침
        </span>
        <span
          className="text-sm font-bold"
          onClick={() =>
            openModal("TERMS_MODAL", {
              title: "약관",
              html: SERVICE_TERMS,
              type: "service",
            })
          }
        >
          서비스 이용약관
        </span>
      </div>
    </footer>
  );
}
